
import { Tbl_teamEdit } from './tbl_teamEdit';
import { Tbl_teamList } from './tbl_teamList';
import { Tbl_teamShow } from './tbl_teamShow';
import { Tbl_teamCreate } from './tbl_teamCreate';
import MapIcon from '@material-ui/icons/Map';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    list: Tbl_teamList,
    edit: Tbl_teamEdit,
    show: Tbl_teamShow,
    create: Tbl_teamCreate,
    icon: MapIcon
};
            